import {IController, IFormController, IModule} from "angular";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {Debugger} from "debug";
import {gettextCatalog} from "angular-gettext";

const debug: Debugger = require('debug')('NyttMøteDetaljerSkjemaKontroller');
const css = require('./behandlingsmåteSkjemafelt.scss');

export class BehandlingsmåteSkjemafeltKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular.component('wmBehandlingsmaateSkjemafelt', {
            bindings: {
                behandlingsmaate: '=',
                skjema: '<'
            },
            controller: BehandlingsmåteSkjemafeltKontroller.forInjisering(),
            template: require('./behandlingsmåteSkjemafelt.html')
        });
    }

    static forInjisering() {
        return [
            regNavn.gettext.gettextCatalog,
            BehandlingsmåteSkjemafeltKontroller
        ]
    }

    constructor(private gettextCatalog: gettextCatalog) {
    }

    behandlingsmaate: string; //settes via bindings
    skjema: IFormController; //settes via bindings

    standardBehandlingsmaater: string[];

    /** i utgangspunktet setter ikke md-autocomplete spesifikasjon.behandlingsMaate før man har valgt et innslag fra drop-downen.
     * Vi ønsker at bruker også skal kunne skrive inn fritekst - derfor setter vi spesifikasjon.behandlingsMaate hver gang søkestreng endres.
     * Dette har den sideeffekt at pil opp/ned for å velge innslag i drop-down ikke fungerer. */
    standardBehandlingsmaaterSoeketekstEndret(søkestreng:string){
        this.behandlingsmaate = søkestreng;
    }

    standardBehandlingsmaaterFiltrert(søkestreng:string){
        søkestreng = søkestreng.toLowerCase();
        return søkestreng ?
            this.standardBehandlingsmaater.filter(kandidat => kandidat.toLowerCase().indexOf(søkestreng) >= 0) :
            this.standardBehandlingsmaater;
    }

    $onInit(): void {
        this.standardBehandlingsmaater = this.initStandardBehandlingsMaater();
    }


    //hjelpemetoder

    private initStandardBehandlingsMaater() {
        return [
            this.gettextCatalog.getString('Fysisk møte'),
            this.gettextCatalog.getString('Videomøte'),
            this.gettextCatalog.getString('Telefonmøte'),
            this.gettextCatalog.getString('E-postmøte'),
            this.gettextCatalog.getString('Kombinasjon')
        ];
    }
}
